module.exports = __webpack_public_path__ + "static_pc/img/ba10.0b987cdc.png";